import { Loader } from '@/helpers/Loader'
import { searchRegistriesSite } from '@/services/Api/actions/registries/actions'
import {
  MktuClass,
  RegistryDatabase,
  RegistrySearchItem,
} from '@/services/Api/generated'
import { FiltersStore } from '@/shared/OnlineSearch/store/Filters.store'
import { captchaControl } from '@/utils/captcha'
import { makeAutoObservable, runInAction } from 'mobx'
import { toast } from 'react-toastify'

export class RegistrySearchStore {
  total: number = 0
  lastPage: number = 0

  searchString: string = ''
  mktuClasses: MktuClass['classNumber'][] = []

  items: RegistrySearchItem[] = []

  additionalFilters = new FiltersStore([
    RegistryDatabase.Rutm,
    RegistryDatabase.Rutmap,
    RegistryDatabase.Wktm,
  ])

  constructor() {
    makeAutoObservable(this, {}, { autoBind: true })
  }

  dataLoader = new Loader(
    async () => {
      try {
        const captcha = await captchaControl.getToken()
        const searchString = this.searchString
        const preparedMktuClasses = this.mktuClasses.join(',')

        const response = await searchRegistriesSite(
          { name: searchString, mktuClasses: preparedMktuClasses },
          captcha
        )

        if (response.status) {
          if (response.pagination != null) {
            runInAction(() => {
              this.total = response.pagination.total ?? 0
              this.lastPage = response.pagination.lastPage ?? 0
            })
          }

          runInAction(() => {
            this.items = response.data
          })
        }
      } catch {
        toast.error('Что то пошло не так! Попробуйте позже')
      }
    },
    {
      withDebounce: true,
    }
  )

  setSearchString(searchString: string) {
    this.searchString = searchString
  }

  setMktuClasses(mktuClasses: MktuClass['classNumber'][]) {
    this.mktuClasses = mktuClasses
  }
}
